/**
 * Created by wwei on 2018-07-27.
 */

import React, { Component } from "react";
import { translate } from "react-i18next";
import { Icon } from "antd";
import { signOut } from "./common/functions/CommonUtils";

class NoRoleRedirect extends Component {
  render = () => {
    const { t } = this.props;
    return (
      <div className="pholio-main-contaner">
        <div className="pholio-header">
          <div className="logo" />
          <div className="product-name">{t("COMMON.TITLE")}</div>
        </div>
        <div className="loginPageContainer">
          <div className="loginpage">
            <div className="loginpage-center">
              <div className="loginpage-inside">
                <div className="login-area" style={{ width: 500 }}>
                  <div
                    className="login-action-area"
                    style={{
                      textAlign: "center",
                      width: 500,
                      color: "#7f7f7f"
                    }}
                  >
                    <div>
                      <Icon
                        type="warning"
                        style={{ color: "#C41C22", fontSize: 70 }}
                      />
                      <div style={{ padding: 20, fontSize: 20 }}>
                        {t("USER.NO_ROLE")}
                      </div>
                      <button
                        className="continue-button"
                        onClick={() => signOut()}
                      >
                        {t("USER.LOGOUT")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
}

export default translate()(NoRoleRedirect);



// WEBPACK FOOTER //
// ./src/NoRoleRedirect.js